import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { PageTransition } from "../components/ui/PageTransition";

export function TermsPage(): ReactNode {
  return (
    <main className="legal-page">
      <PageTransition>
        <div className="legal-content">
          <h1>Terms of Service</h1>
          <p className="legal-updated">Last updated: March 2026</p>

          <h2>1. Acceptance of Terms</h2>
          <p>
            By creating an account or using this service, you agree to these Terms of Service. If
            you do not agree, do not use the service.
          </p>

          <h2>2. Description of Service</h2>
          <p>
            This service provides AI-powered bookkeeping assistance, including transaction import,
            automated categorization, and financial organization tools. The service is not a
            licensed accounting firm and does not provide tax advice, audit services, or legal
            counsel.
          </p>

          <h2>3. AI Processing</h2>
          <p>
            Your financial transaction data is processed by AI systems to provide categorization
            suggestions and bookkeeping insights. You retain full control over all categorization
            decisions. AI suggestions are not financial or tax advice.
          </p>

          <h2>4. Your Data</h2>
          <p>
            You own your financial data. You may export or delete your data at any time. We do not
            sell your data to third parties. See our <Link to="/privacy">Privacy Policy</Link> for
            details on how your data is stored and processed.
          </p>

          <h2>5. Account Responsibilities</h2>
          <p>
            You are responsible for maintaining the security of your account credentials. You are
            responsible for all activity that occurs under your account. Notify us immediately of
            any unauthorized access.
          </p>

          <h2>6. Limitation of Liability</h2>
          <p>
            This service is provided &quot;as is&quot; without warranties of any kind. We are not
            liable for any errors in AI categorization, data loss, or financial decisions made based
            on information provided by the service. Always consult a qualified accountant or tax
            professional for financial advice.
          </p>

          <h2>7. Changes to Terms</h2>
          <p>
            We may update these terms from time to time. Continued use of the service after changes
            constitutes acceptance of the new terms.
          </p>

          <div className="legal-nav">
            <Link to="/signup">Back to sign up</Link>
            {" | "}
            <Link to="/privacy">Privacy Policy</Link>
          </div>
        </div>
      </PageTransition>
    </main>
  );
}
